/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum KycDocumentStatus {
    NOT_UPLOADED = 'NOT_UPLOADED',
    NOT_REQUIRED = 'NOT_REQUIRED',
    UPLOADED_NOT_VERIFIED = 'UPLOADED_NOT_VERIFIED',
    UPLOADED_REJECTED = 'UPLOADED_REJECTED',
    UPLOADED_APPROVED = 'UPLOADED_APPROVED',
    MORE_DOCUMENTS_REQUESTED = 'MORE_DOCUMENTS_REQUESTED',
}
